import { authClient, getServiceURL } from '@/utils'

const fetchInvoices = ({
	clientCode,
	search,
	sortBy,
	page,
	limit
}) => {

	return authClient.get(`${getServiceURL('sr-erp')}/v1/invoices/${clientCode}`, {
		params: {
			search,
			sortBy,
			page,
			limit,
		}
	})
}

export default {
	fetchInvoices
}
